import { Box, TableCell, TableRow } from '@occc-app/design-system';
import { TrendBadge, TrendBadgeDelta } from '@occc/ui-design-system';

import { formatInt, formatUsdCents } from '../tobacco-submissions.utils';
import { RetailerNetworkScanDataSiteSubmission } from '../tobacco-submissions.types';

type TobaccoStoreSubmissionsTableRowProps = {
  item: RetailerNetworkScanDataSiteSubmission;
};

export const TobaccoStoreSubmissionsTableRow = ({ item }: TobaccoStoreSubmissionsTableRowProps) => {
  const altria = item.submissions.find((v) => v.type === 'CIRCANA_ALTRIA');
  const rjr = item.submissions.find((v) => v.type === 'CIRCANA_RJR');
  const msa = item.submissions.find((v) => v.type === 'MSA');
  const reimbursement =
    item.estimatedReimbursements.multiUnit + item.estimatedReimbursements.loyalty;

  return (
    <TableRow key={item.siteId} hover>
      <TableCell>{item.siteId}</TableCell>
      <TableCell>{item.siteName}</TableCell>
      <TableCell>
        {altria ? (
          <TrendBadge
            color={altria.status === 'SUBMITTED' ? 'green' : 'red'}
            label={altria.status === 'SUBMITTED' ? 'Yes' : 'No'}
          />
        ) : (
          <TrendBadge color='gray' label='N/A' />
        )}
      </TableCell>
      <TableCell>
        {rjr ? (
          <TrendBadge
            color={rjr.status === 'SUBMITTED' ? 'green' : 'red'}
            label={rjr.status === 'SUBMITTED' ? 'Yes' : 'No'}
          />
        ) : (
          <TrendBadge color='gray' label='N/A' />
        )}
      </TableCell>
      <TableCell>
        {msa ? (
          <TrendBadge
            color={msa.status === 'SUBMITTED' ? 'green' : 'red'}
            label={msa.status === 'SUBMITTED' ? 'Yes' : 'No'}
          />
        ) : (
          <TrendBadge color='gray' label='N/A' />
        )}
      </TableCell>
      <TableCell>
        <Box display='inline-flex' alignItems='center' gap={1}>
          <TrendBadgeDelta
            value={item.totalMultiUnitTransactions}
            prevValue={item.previousTotalMultiUnitTransactions}
          />
          {formatInt(item.totalMultiUnitTransactions)}
        </Box>
      </TableCell>
      <TableCell>
        <Box display='inline-flex' alignItems='center' gap={1}>
          <TrendBadgeDelta
            value={item.totalLoyaltyTransactions}
            prevValue={item.previousTotalLoyaltyTransactions}
          />
          {formatInt(item.totalLoyaltyTransactions)}
        </Box>
      </TableCell>
      <TableCell align='right'>{formatUsdCents(reimbursement)}</TableCell>
    </TableRow>
  );
};
